import { render, staticRenderFns } from "./SubSidenav.vue?vue&type=template&id=c36e5080&"
import script from "./SubSidenav.vue?vue&type=script&lang=js&"
export * from "./SubSidenav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports